import { CampaignChannel } from '../types/campaigns'

export const SUPPORTED_CHANNELS: CampaignChannel[] = ['EMAIL', 'SMS']

// Filtros de Messaging templates persistidos en localStorage.
export const TEMPLATE_FILTER_KEYS = {
  search: 'templates_filter_search',
  channel: 'templates_filter_channel',
  blueprint: 'templates_filter_blueprint',
  owner: 'templates_filter_owner',
  org: 'templates_filter_org',
  pageSize: 'templates_filter_page_size',
  showArchived: 'templates_filter_show_archived',
} as const

export const CHANNEL_LABELS: Record<CampaignChannel, string> = {
  EMAIL: 'Email',
  WHATSAPP: 'WhatsApp',
  SMS: 'SMS',
  TELEGRAM: 'Telegram',
}

export const CHANNEL_ICONS: Record<CampaignChannel, string> = {
  EMAIL: '📧',
  WHATSAPP: '💬',
  SMS: '💬',
  TELEGRAM: '✈️',
}

export const CHANNEL_COLORS: Record<CampaignChannel, string> = {
  EMAIL: 'success',
  WHATSAPP: 'info',
  SMS: 'primary',
  TELEGRAM: 'warning',
}
